<script lang="ts">
  import { twMerge } from 'tailwind-merge';

  export let tag: string = 'h2';
  export let title: string;
  export let titleClasses: string | null = null;
  export let hrClasses: string | null = null;
</script>

<div class={twMerge('flex items-center', $$restProps.class)}>
  <svelte:element this={tag} class={twMerge('mr-4', titleClasses)}>
    {title}
  </svelte:element>
  <hr class={twMerge('border-1.5 hidden grow bg-gray-100 md:block', hrClasses)} />
</div>

<!--
@component
Divider Heading combines a heading with a visual divider to clearly separate and label different sections of content
## Props
@prop tag: string = $$restProps.href ? 'a' : 'div';
@prop title: string;
@prop titleClasses: string | null = null;
-->
